export default __webpack_public_path__ + "static/media/bg.6a75f026.png";